import { createThunkRequest, DELETE, GET, POST } from '@webapp/account/src/libs/request';
import { selectReports } from '@webapp/account/src/resources/reports/selectors';

export const createFilterGroup = createThunkRequest(
    'reports/createFilterGroup',
    async (
        {
            surveyId,
            name,
        }: {
            surveyId: number;
            name: string;
        },
        { getState },
    ) => {
        const { globalFilters } = selectReports(getState());

        return await POST('add/filter_group', {
            surveyId,
            name,
            filtersData: globalFilters as Record<string, any>,
        });
    },
);

export const removeFilterGroup = createThunkRequest(
    'reports/removeFilterGroup',

    (id: number) => {
        return DELETE(`delete/filter_group/${id}`);
    },
);

export const getFilterGroups = createThunkRequest(
    'reports/getFilterGroups',
    ({ surveyId }: { surveyId: number }) => {
        return GET('show/filter_groups', { surveyId });
    },
    { notify: false },
);
